import { render, staticRenderFns } from "./ConvenioEmissaoDocumentos.vue?vue&type=template&id=9b2b898c"
import script from "./ConvenioEmissaoDocumentos.vue?vue&type=script&lang=js"
export * from "./ConvenioEmissaoDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports